<template>
  <section class="p-2">
    <div class="mt-5">
      <v-form ref="Addform" v-model="valid">
        <v-card flat outlined class="  ">
          <v-card-title class="d-flex justify-space-between p-0 m-0">
            <div class="ps-2 headingFontsize">Customer Profile</div>
            <div>
              <bread-crumb :bread-crumbs="['Deals', 'New Deal']" />
            </div>
          </v-card-title>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <v-toolbar flat dense>
            <v-toolbar-title v-if="!updateTrigger" class=""
              >Contract Details</v-toolbar-title
            >
            <v-toolbar-title v-if="updateTrigger" class="">Basic Details</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center">
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">Contract Type</label>
                <v-autocomplete
                  :items="dealOption"
                  v-model="dealDetails.deal_type"
                  outlined
                  dense
                  placeholder="Contract Type"
                  class="rounded"
                  :rules="FieldRequired('Contract Type')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="my-0 labelFontsize required">Booking Date</label>
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="dealDetails.deal_date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dealDetails.deal_date"
                      required
                      outlined
                      dense
                      class="rounded"
                      placeholder="Booking Date"
                      :rules="FieldRequired('Booking Date')"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dealDetails.deal_date"
                    scrollable
                    :min="getMindate()"
                    :max="getMaxdate()"
                  >
                    <v-spacer></v-spacer>
                    <v-btn depressed text color="primary" @click="modal = false">
                      <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
                    </v-btn>
                    <v-btn
                      depressed
                      text
                      color="primary"
                      @click="$refs.dialog.save(dealDetails.deal_date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="my-0 labelFontsize required">Contract No</label>
                <v-text-field
                  outlined
                  dense
                  placeholder="Contract No"
                  class="rounded"
                  v-model="dealDetails.deal_no"
                  :rules="[...contract_type, ...FieldRequired('Contract No')]"
                  @input="CheckDealNo()"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" xs="6">
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="my-0 labelFontsize required"
                  >Foreign Currency Amount(USD)</label
                >
                <v-text-field
                  v-model="dealDetails.fcy_amount"
                  :rules="FieldNumbRequired('FCY')"
                  @change="handleChange"
                  @input="handleChange()"
                  type="number"
                  hide-spin-buttons
                  @keydown="filterNumberInput"
                  placeholder="Foreign Currency Amount"
                  outlined
                  preifx="USD"
                  dense
                  class="rounded"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">Contract Rate</label>
                <v-text-field
                  v-model="dealDetails.fcy_deal_rate"
                  :rules="FieldNumbRequired('Contract Rate')"
                  @input="handleChange()"
                  placeholder="Contract Rate"
                  type="number"
                  hide-spin-buttons
                  @keydown="filterNumberInput"
                  outlined
                  dense
                  class="rounded"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize">LCY Amount</label>
                <v-text-field
                  v-model="dealDetails.lcy_amount"
                  @input="handleChange()"
                  placeholder="LCY Amount"
                  disabled
                  outlined
                  dense
                  class="rounded"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">Source of funds</label>
                <v-text-field
                  v-if="dealDetails.deal_type !== 'O'"
                  v-model="dealDetails.source_of_funds"
                  required
                  outlined
                  placeholder="Source of funds"
                  dense
                  class="rounded"
                  :rules="FieldRequired('Source of Funds')"
                >
                </v-text-field>
                <v-select
                  v-if="dealDetails.deal_type === 'O'"
                  v-model="dealDetails.source_of_funds"
                  :items="fundSourceOption"
                  outlined
                  dense
                  class="rounded"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required"> Confirmation Date</label>
                <v-dialog
                  ref="purchase_datedialog"
                  v-model="purchase_datedialog"
                  :return-value.sync="dealDetails.purchase_date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dealDetails.purchase_date"
                      required
                      outlined
                      dense
                      class="rounded"
                      placeholder="Confirmation Date"
                      :rules="FieldRequired('Confirmation Date')"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dealDetails.purchase_date"
                    scrollable
                    :min="purchaseMindate()"
                    :max="purchaseMaxdate()"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      depressed
                      text
                      color="primary"
                      @click="purchase_datedialog = false"
                    >
                      <v-icon small class="me-2">mdi-close-circle-outline</v-icon>
                      Cancel
                    </v-btn>
                    <v-btn
                      depressed
                      text
                      color="primary"
                      @click="$refs.purchase_datedialog.save(dealDetails.purchase_date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize">Contract Person</label>
                <v-text-field
                  v-model="dealDetails.bank_poc"
                  class="rounded"
                  outlined
                  dense
                  placeholder="Contractor"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-toolbar flat dense class="my-5" v-if="updateTrigger">
              <v-toolbar-title>Audit Details</v-toolbar-title>
            </v-toolbar>

            <v-row class="" v-if="updateTrigger">
              <v-col cols="12" md="6">
                <label class="my-0 labelFontsize">Created By</label>
                <v-text-field
                  v-model="dealDetails.created_by"
                  disabled
                  required
                  outlined
                  dense
                  class="rounded"
                  placeholder="Created By"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <label class="my-0 labelFontsize"> Created Date</label>
                <v-text-field
                  type="date"
                  required
                  outlined
                  dense
                  class="rounded"
                  v-model="dealDetails.created_date"
                  disabled
                  placeholder="Created Date"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <label class="my-0 labelFontsize">Updated By</label>
                <v-text-field
                  v-model="dealDetails.updated_by"
                  disabled
                  required
                  outlined
                  dense
                  class="rounded"
                  placeholder="Updated By"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="my-0 labelFontsize"> Updated Date</label>
                <v-text-field
                  type="date"
                  required
                  outlined
                  dense
                  class="rounded"
                  v-model="dealDetails.updated_date"
                  placehoder=" Updated Date"
                  disabled
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <label class="my-0 labelFontsize">Remarks</label>
                <v-textarea
                  outlined
                  v-model="dealDetails.remarks"
                  rows="3"
                  class="rounded"
                  max-rows="6"
                  disabled
                  placeholder="Remarks"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row justify="end">
              <v-btn
                depressed
                small
                color="primary"
                class="mb-15 me-2 text-capitalize"
                v-on:click="onSubmitFor()"
              >
                <v-icon small class="me-2">mdi-content-save-check-outline</v-icon
                >{{ updateTrigger ? "Update" : "Submit" }}
              </v-btn>

              <v-btn
                depressed
                color="primary"
                class="me-5 mb-10 text-capitalize"
                outlined
                small
                v-on:click="oncancel()"
              >
                <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </div>
    <OverlayPageVue :showOverlay="loaderOverlay" />
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import alerts from "@/mixins/alerts";
import treasuryService from "@/services/TreasuryService/treasuryService.js";
import commonService from "@/services/CommonService/commonService.js";
import { FieldRequired, FieldNumbRequired } from "@/utils/validation.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
export default {
  name: "New Deal",
  mixins: [alerts],
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  computed: {},
  data() {
    return {
      valid: true,
      FieldRequired,
      FieldNumbRequired,
      filterNumberInput,
      updateTrigger: false,
      loaderOverlay: false,
      dealList: [],
      contract_type: [],
      dealOption: [],
      fundSourceOption: [{ value: "Public Bank MYR", text: "Public Bank MYR" }],
      targetOfFundOption: [{ value: "Target Bank USD", text: "Target Bank USD" }],
      modal: false,
      purchase_datedialog: false,
      menu1: false,
      dealDetails: {
        deal_type: "",
        deal_date: null,
        deal_no: "",
        fcy_amount: "", // USD Amt
        fcy_deal_rate: "",
        lcy_amount: "", //MYR Amt
        source_of_funds: "Public Bank MYR",
        purchase_date: null,
        bank_charge: 0,
        tof: "Target Bank USD", // Target of fund
        bank_poc: "",
        tax: "",
        remarks: "",
        no_of_settlements: "",
        status: "",
      },
    };
  },

  watch: {},

  mounted() {
    this.getdropdowntypes("DCT");
    if (this.$route.query.id) {
      this.updateTrigger = true;
      this.getSelectedDeal(this.$route.query.id);
    } else {
      this.updateTrigger = false;
      this.dealDetails.status = "open";
      this.dealDetails.no_of_settlements = 0;
    }
  },

  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    getMindate() {
      let d = new Date();
      d.setDate(d.getDate() - 1);
      return d.toISOString().split("T")[0];
    },
    getMaxdate() {
      let d = new Date();
      d.setDate(d.getDate() + 1);
      return d.toISOString().split("T")[0];
    },
    purchaseMindate() {
      let d = new Date();
      d.setDate(d.getDate());
      return d.toISOString().split("T")[0];
    },
    purchaseMaxdate() {
      let d = new Date();
      d.setDate(d.getDate() + 2);
      return d.toISOString().split("T")[0];
    },
    async getSelectedDeal(id) {
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.getSelectedDeal(id);
        console.log(responseData, "response");
        if (responseData && responseData.data.status_code == 200) {
          this.dealDetails = responseData.data.data[0];
          this.dealDetails.purchase_date = this.dealDetails.purchase_date?.split("T")[0];
          this.dealDetails.created_date = this.dealDetails.created_date?.split("T")[0];
          this.dealDetails.updated_date = this.dealDetails.updated_date?.split("T")[0];
          this.stoploader();
        } else {
          this.loaderOverlay = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (err) {
        console.log(err);
        this.loaderOverlay = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },
    async CheckDealNo() {
      try {
        const responseData = await treasuryService.validateDeal(this.dealDetails.deal_no);
        if (responseData && responseData.data.status_code == 202) {
          this.contract_type = [];
        } else {
          this.contract_type.push(responseData.data.message);
        }
        console.log("response", responseData.data.status_code);
      } catch (e) {
        this.contract_type = [];
        console.log(e);
      }
    },

    formatUSD(num) {
      return Number(num)
        .toString()
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    },
    parseUSD(text) {
      if (typeof text === "string") {
        return Number(text.replace("$", "").replace(/,/g, ""));
      } else {
        return text;
      }
    },
    handleChange() {
      if (this.dealDetails.fcy_amount != "" && this.dealDetails.fcy_deal_rate != "") {
        var temp_lcy_amount = (
          this.parseUSD(this.dealDetails.fcy_amount) * this.dealDetails.fcy_deal_rate
        ).toFixed(2);
        this.dealDetails.lcy_amount = this.formatUSD(temp_lcy_amount);
        this.dealDetails.remarks =
          "Buying an amount of " +
          this.dealDetails.fcy_amount +
          " USD at an exchange rate of " +
          this.dealDetails.fcy_deal_rate +
          " by converting an amount of " +
          this.dealDetails.lcy_amount +
          " MYR";
      }
    },
    onSubmitFor() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        if (this.dealDetails.deal_id) {
          console.log("details");
          this.update();
        } else {
          console.log("else");
          this.save();
        }
      }
    },
    oncancel() {
      this.$v.$reset();
      this.dealDetails = {
        deal_type: "",
        deal_date: "",
        deal_no: "",
        fcy_amount: "",
        fcy_deal_rate: "",
        lcy_amount: "",
        source_of_funds: "Public Bank MYR",
        purchase_date: "",
        bank_charge: 0,
        tof: "Target Bank USD",
        bank_poc: "",
        tax: "",
        remarks: "",
        no_of_settlements: "",
        status: "",
      };
    },
    async update() {
      const request = this.getRequest();
      request.fcy_amount = this.parseUSD(request.fcy_amount);
      request.lcy_amount = this.parseUSD(request.lcy_amount);
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.updateContract(
          request.deal_id,
          request
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.stoploader();
          setTimeout(() => this.$router.push({ name: "Deals" }), 300);
        } else {
          this.loaderOverlay = false;
          this.showAlertError("Failed:" + responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (err) {
        console.log(err);
        this.loaderOverlay = false;
        this.showAlertError("Something went wrong");
      }
    },
    async save() {
      const request = this.getRequest();
      request.fcy_amount = this.parseUSD(request.fcy_amount);
      request.lcy_amount = this.parseUSD(request.lcy_amount);
      // request.purchase_date = request.purchase_date?.split("T")[0];
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.addContract(request);
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.stoploader();
          setTimeout(() => this.$router.push({ name: "Deals" }), 300);
        } else {
          this.loaderOverlay = false;
          this.showAlertError("Failed:" + responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (err) {
        console.log(err);
        this.loaderOverlay = false;
        this.showAlertError("One or more parameter is invalid or missing!");
      }
    },
    getRequest() {
      const req = this.dealDetails;
      for (const key of Object.keys(req)) {
        if (
          key === "updated_date" ||
          key === "approved_aate" ||
          key === "authorized_date"
        ) {
          if (req[key]) {
            req[key] = new Date(req[key]);
          }
        }
      }
      return req;
    },
    formatDateFields() {
      if (this.dealDetails && this.dealDetails.purchase_date)
        this.dealDetails.purchase_date = this.dealDetails.purchase_date.slice(0, 10);
      if (this.dealDetails && this.dealDetails.created_date)
        this.dealDetails.created_date = this.dealDetails.created_date.slice(0, 10);
      if (this.dealDetails && this.dealDetails.updated_date)
        this.dealDetails.updated_date = this.dealDetails.updated_date.slice(0, 10);
      if (this.dealDetails && this.dealDetails.fund_date)
        this.dealDetails.fund_date = this.dealDetails.fund_date.slice(0, 10);
    },
    async getdropdowntypes(code) {
      try {
        const response = await commonService.getparameterdropdowns(code);
        if (response.data.status_code === 200) {
          console.log("DCT", response.data.data);
          this.dealOption = response.data.data.map((i) => {
            return { text: i.value, value: i.value_code };
          });
        }
      } catch (error) {
        console.error("Error fetching :", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
